import axios from '@/plugins/axios';

const EVENT_WON_BID_LIST = 'event-won-bid-list';
const UPDATE_FIRST_VIEW = 'update-status-first-view';
const UPDATE_FIRST_VIEW_BIDDING = 'update-bidding-status-first-view';

export async function getListEventWonBid(payload) {
  try {
    const { data } = await axios.get(EVENT_WON_BID_LIST, { params: payload });
    return data;
  } catch (err) {
    return { err };
  }
}

export async function updateFirstView(payload) {
  try {
    const { data } = await axios.post(UPDATE_FIRST_VIEW, payload);
    return data;
  } catch (err) {
    return { err };
  }
}

export async function updateFirstViewBidding(payload) {
  try {
    const { data } = await axios.post(UPDATE_FIRST_VIEW_BIDDING, payload);
    return data;
  } catch (err) {
    return { err };
  }
}
